import type { Job, JobEvent } from "@webyonetim/contracts";

import { applyJobEvent } from "../features/projects/JobProgress";

/** Keep a lifecycle result provisional until the durable job projection says it finished. */
export function applyOperationEvents(
  current: Job | undefined,
  events: readonly JobEvent[],
): Job | undefined {
  return events.reduce(applyJobEvent, current);
}

export function observationStateLabel(state: "confirmed" | "stale" | "disconnected"): string {
  if (state === "confirmed") return "Doğrulandı";
  if (state === "stale") return "Son doğrulanan veri eski";
  return "Bağlantı kesildi";
}
